import { Link } from 'react-router-dom';
import { categories } from '@/mocks/comics';

export default function CategorySection() {
  return (
    <section className="max-w-[1280px] mx-auto px-4 md:px-6 py-14 md:py-20">
      <div className="text-center mb-10">
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
          漫画<strong>分类</strong>
        </h2>
        <p className="text-sm text-foreground-500 max-w-lg mx-auto">
          按类别浏览您喜爱的星际科幻漫画，找到属于您的宇宙冒险故事
        </p>
      </div>
      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-4">
        {categories.map((cat) => (
          <Link
            key={cat.slug}
            to={`/category/${cat.slug}`}
            className="group flex flex-col items-center gap-3 p-5 rounded-lg bg-background-100 hover:bg-background-200/70 transition-colors cursor-pointer"
          >
            <div className="w-12 h-12 flex items-center justify-center rounded-full bg-accent-100 text-accent-600 group-hover:bg-accent-500 group-hover:text-background-50 transition-all duration-300">
              <i className={`${cat.icon} text-xl`}></i>
            </div>
            <span className="text-sm font-medium text-foreground-800 group-hover:text-primary-500 transition-colors whitespace-nowrap">
              {cat.name}
            </span>
            <span className="text-xs text-foreground-400 text-center leading-relaxed line-clamp-2">
              {cat.description}
            </span>
          </Link>
        ))}
      </div>
    </section>
  );
}